<template>
  <div>
    <van-popup
      v-model="show"
      class="full-height full-width verificate linear-main3"
      :get-container="element || ''"
      close-on-popstate
      position="right"
    >
      <ld-header
        @click-left="show = false"
        class="font-lg white"
        transparent
        white
      >
        手机短信核验
      </ld-header>
      
      <div class="pad8 bg-white round-lg">
        <van-row class="font12 mt5 gray padLR8">
          您当前的登录账号需要进行手机号核验。12306规定，手机号码核验通过方可购票，请按以下步骤完成核验。
        </van-row>

        <van-row class="verificate-box mt5 round-md">
          <van-row class="font-bold font20 mt5">
            1. 发送 <span class="main-color">666</span> 至 12306
          </van-row>
          <van-row class="mt5">
            {{ smsCheckMsg || '请用您手机发送 666 至 12306' }}，每天至多发送3次。
          </van-row>
          <van-row class="font-bold font20 mt5">
            2. 输入短信验证码，完成核验
          </van-row>
          <van-row class="mt5">
            发送短信后，将收到 12306 发送给您的六位数字验证码，请输入验证码
          </van-row>
          

          <van-row class="verificate-box__buttons">
            <van-field
              v-model="verificateCode"
              class="text-space round-md mt5"
              :placeholder="$t('G235','请输入验证码')"
            />
          </van-row>

          <van-row class="verificate-box__buttons">
            <ld-button
              class="mt5"
              main2
              size="lg"
              @click="verificate"
            >
              完成核验
            </ld-button>
          </van-row>
        </van-row>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Search, Popup, Cell, CellGroup, Field } from 'vant'
import ldButton from 'Common/ldButton'

export default {
  name: 'Verificate',
  components: {
    [Popup.name]: Popup,
    [Search.name]: Search,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    ldButton
  },
  props: {
    element:{
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: () => ''
    },
    password: {
      type: String,
      default: () => ''
    },
    smsCheckMsg: {
      type: String,
      default: () => ''
    },
    verificationnew:''
  },
  data() {
    return {
      show: false,
      verificateCode: ''
    }
  },
  methods: {
    async verificate () {
      if (!this.verificateCode) {
        this.$dialog.alert({ message: '验证码不能为空'})
        return
      }
      try {
        if (this.verificationnew == 'traverList') { //核验使用此页面
          this.$emit('success', this.verificateCode)
          this.toggle()
          this.verificateCode = ''
          return
        }
        const param = {
          userName: this.userName,
          password: this.password,
          yzm: this.verificateCode
        }
        await this.$api['trQuery/sendCheckAccountYzm'](param)

        this.$toast.success('账号核验成功')
        this.toggle()
        this.$emit('success')
      } catch (error) {
        this.$toast.fail(error.errMsg)
        throw error
      }
    },
    toggle() {
      this.show = !this.show
    }
  }
}
</script>

<style lang="less">
.verificate {
  padding: 0 8px 0;

  .verificate-box {
    padding: 14px;
    background-color: @color-background-gray;

    .verificate-box__buttons {
      margin-top: 14px;
    }
  }

  .verificate-status {
    margin-top: 10px;
    padding: 16px;
  }

  .padLR8 {
    padding: 0 8px;
  }
}
</style>
